import {
  Color,
  Header,
  Paragraph
} from '@eggplant/pattern-library'
import { LinkToTestManagementToolsDoc } from '../links'

const IntegrationZephyrAssignedToID = () =>
  <div className='grid gap-4'>
    <div className='grid gap-3'>
      <Header
        hasNoTopMargin
        lessWeight
        rank={3}
      >
        Assigned to ID
      </Header>
      <Paragraph>
        <strong>
          <Color variant='theme-description-text'>
            The Jira user ID of the person assigned to this test. This ID is generated and managed by Jira. To view or update the assignee, open the item in Jira and edit the Assignee field.
          </Color>
        </strong>
      </Paragraph>
    </div>
    <Paragraph>
      <LinkToTestManagementToolsDoc />
    </Paragraph>
  </div>

export default IntegrationZephyrAssignedToID
